import React from "react";

const CupTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">ARCA MENARDS SERIES</h2>
        <p className='pb-1 lh-base' data-aos="fade-up" data-aos-delay="100">The ARCA Menards Series was formerly known as the ARCA Racing Series Presented by Menards (2011-2018), the ARCA Racing Series Presented by Re/Max & Menards (2010), ARCA Re/Max Series (2001-2009), ARCA Bondo/Mar-Hyde Series (1995-2000), ARCA Hooters Cup Super Car Series (1993-1994), ARCA Permatex Super Car Series (1986-1992), ARCA Talladega Super Car Series (1982-1985), ARCA Racing Series (1964-1981) and Midwest Association for Race Cars (MARC) (1953-1963).</p>
       
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
              <tr style={{ width: "100%" }}>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                Races
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "30%" }}>
                Champion
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "30%" }}>
                Rookie of the Year
                </th>
          
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
            
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
          
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
           
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
    
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
            </tr>
            <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
            
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
          
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
           
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
    
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
            </tr>
          
            </tbody>
          </table>
      
       
        </div>
      </section>
    </>
  );
};

export default CupTable;
